import { useCallback } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import useGetLocalePath from "../../hooks/useGetLocalePath";

import { Link } from "react-router-dom";

import { setHeaderMenuOpen } from "../../redux/reducers/uiReducer";

import Button from "../button";

function Toolbar() {
  const { t } = useTranslation();
  const { getLocalePath } = useGetLocalePath();

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);

  const manageOpenMenu = useCallback(
    (isOpen) => {
      dispatch(setHeaderMenuOpen(isOpen));
    },
    [dispatch]
  );

  const redirectGetLocalePath = useCallback(
    (path) => {
      return `${process.env.REACT_APP_PUBLIC_URL}${getLocalePath(path)}`;
    },
    [getLocalePath]
  );

  return (
    <div className="toolbar">
      <Link
        to={redirectGetLocalePath(t("routes.public.uploader"))}
        title={t("uploader_page.title")}
      >
        <Button secondary icon onClick={() => manageOpenMenu(false)}>
          <span className="icon icon-circle-add-alternate"></span>
          <span className="label small-title">{t("button.add")}</span>
        </Button>
      </Link>
      <Button
        secondary
        icon
        onClick={(evt) => manageOpenMenu(!ui.header_menu_open)}
      >
        <span
          className={`icon ${
            ui.header_menu_open ? "icon-delete-circled-outline" : "icon-menu"
          }`}
        ></span>
        <span className="label small-title">{t("button.menu")}</span>
      </Button>
    </div>
  );
}

export default Toolbar;
